import '../bootstrap';
import '../directives';
import '../filters';
import './components';

import Slider from '../src/core/Slider';
import Scroller from '../src/core/Scroller';
import Gtag from '../src/core/Gtag';

import Media from '../src/mixins/Media';

(new Vue({
    el: '#app',
    mixins: [Media],
    data: {
        search: {
            opened: false
        }
    },
    mounted() {
        window.addEventListener(
            'click',
            event => window.EventHandler.fire('body-clicked', event)
        );

        new Gtag;
        new Slider;
        new Scroller;
    },
    methods: {
        backgroundImage(paths) {
            return {
                backgroundImage: 'url(\'' + paths[this.media] + '\')'
            }
        }
    }
}));